import React, { useState } from 'react';
import { Button } from '../../components/Button';
import { Popup } from '../../components/Popup';
import { VideoPlayer } from '../../components/VideoPlayer';
import { setTariff } from '../../api/tariff';
import { useDispatch } from 'react-redux';
import { addNotification } from '../../shared/store/slices/notificationSlice';

import styles from './styles.module.scss'

export const TariffPage = () => {
  const [video, setVideo] = useState(null);

  const dispatch = useDispatch();

  const changeTariff = (status) => {
    setTariff(status)
        .then((response) => {
            dispatch(addNotification(response));
        })
        .catch((error) => {
            dispatch(addNotification(error.message));
        });
};

  return (
    <div className={styles.tariffPage}>
      <h1>Тариф</h1>
      <p>
        Вебинар по цифровой партнерской системе DebtKiller<br/>
        <a href='https://vk.com/wall164225163_3947'>Смотреть вебинар</a>
      </p>

      <div className={styles.cards}>
        <div className={styles.card}>
          <p className={styles.text}>
            Тариф «PRO»
          </p>
          
          <button className={styles.moreDetailsButton} onClick={() => {setVideo('/')}}>
            Подробнее о тарифе
          </button>

          <span className={styles.price}>
            150 000 ₽
          </span>

          <Button onClick={() => changeTariff(1)}>Подключить</Button>
        </div>

        <div className={styles.card}>
          <p className={styles.text}>
            Тариф «Бизнес»
          </p>
          
          <button className={styles.moreDetailsButton} onClick={() => {setVideo('/')}}>
            Подробнее о тарифе
          </button>

          <span className={styles.price}>
            300 000 ₽
          </span>

          <Button onClick={() => changeTariff(2)}>Подключить</Button>
        </div>
      </div>
      {video &&
        <Popup close={() => {setVideo(null)}} onWrapperClick={() => {setVideo(null)}}>
          <div className={styles.video}>
            <VideoPlayer source={video}/>
          </div>
        </Popup>
      }
    </div>
  );
};
